export default "__VITE_ASSET__dfe40a45__"